<div class="internal-server-error">
  <div class="internal-server-error-message">
    <div class="message-sub-heading"> Whoopsie! </div>
    <div class="message-text">
      <h2>{{ message }}</h2>
      @if (!error) {
        <a mat-raised-button [routerLink]="['/']">Back to Home</a>
      } @else {
        <button mat-raised-button (click)="reloadPage()">Reload page</button>
        <button mat-raised-button (click)="showErrorDetails()">More Details</button>
      }
    </div>
  </div>
  <div class="internal-server-error-heading">
    <h1>500</h1>
  </div>
</div>
